import { LayoutDashboard, FlaskConical, GitBranch, Workflow, Users, CreditCard, Crown, FolderKanban, ListChecks, Target } from 'lucide-react';

export const mainNavigation = [
    {
      name: 'Dashboard',
      view: 'dashboard',
      icon: LayoutDashboard,
      description: 'Overview & analytics'
    },
    {
      name: 'API Testing',
      view: 'api-testing',
      icon: FlaskConical,
      description: 'Test REST APIs'
    },
    {
      name: 'Flow Testing',
      view: 'flow-testing',
      icon: Workflow,
      description: 'E2E test flows'
    },
    {
      name: 'Test Suites',
      view: 'test-suites',
      icon: ListChecks,
      description: 'Batch test execution'
    },
    {
      name: 'Sprint QA',
      view: 'sprint-qa',
      icon: Target,
      description: 'QA lifecycle management'
    },
    {
      name: 'Projects',
      view: 'projects',
      icon: FolderKanban,
      description: 'Manage projects'
    },
    {
      name: 'CI/CD',
      view: 'cicd',
      icon: GitBranch,
      description: 'Pipeline integration'
    }
  ];

// Role restrictions are applied by UserSidebarLayout.
export const allBottomNavigation = [
    {
      name: 'Team',
      view: 'team',
      icon: Users,
      description: 'Manage team members',
      adminOnly: true
    },
    {
      name: 'Billing',
      view: 'billing',
      icon: CreditCard,
      description: 'Payments & invoices',
      adminOnly: true
    },
    {
      name: 'Plans',
      view: 'plans',
      icon: Crown,
      description: 'Upgrade your plan',
      adminOnly: false  // TEMPORARILY enabled for testing
    }
  ];
